// src/components/Registros/Registros.jsx
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { FaCalendarAlt, FaFileAlt, FaBriefcase, FaUserMd, FaGraduationCap, FaBox, FaShoppingCart, FaDollarSign, FaLaptop, FaClock } from 'react-icons/fa';
import InsumoForm from './forms/InsumoForm';
import DotacionForm from './forms/DotacionForm';
import CapacitacionForm from './forms/CapacitacionForm';
import IncapacidadForm from './forms/IncapacidadForm';
import CompensatorioForm from './forms/CompensatorioForm';
import TeletrabajoForm from './forms/TeletrabajoForm';
import EquipamientoForm from './forms/EquipamientoForm';
import './Registros.css';
import PermisoForm from './forms/PermisoForm';
import VacacionesForm from './forms/VacacionesForm';
import { useAuth } from '../../hooks/useAuth';
import HorasExtrasForm from './forms/HorasExtrasForm';

const Registros = () => {
  const [selectedType, setSelectedType] = useState(null);
  const [registros, setRegistros] = useState([]);
  const [loading, setLoading] = useState(false);
  const {userData}=useAuth()

  // Definición de tipos de registro
  const tiposRegistro = [
    {
      id: 'permiso',
      nombre: 'Permiso',
      descripcion: 'Solicitar permisos personales, médicos o familiares',
      icon: FaClock,
      color: '#0d6efd',
      component: PermisoForm
    },
    {
      id: 'vacaciones',
      nombre: 'Vacaciones',
      descripcion: 'Solicitar días de vacaciones',
      icon: FaCalendarAlt,
      color: '#0dcaf0',
      component: VacacionesForm
    },
    /*{
      id: 'egreso_viatico',
      nombre: 'Egreso de Viático',
      descripcion: 'Registrar entrega de viáticos a técnicos',
      icon: FaDollarSign,
      color: '#198754',
      component: EgresoViaticoForm
    },*/
    {
      id: 'insumo',
      nombre: 'Insumo',
      descripcion: 'Solicitar insumos o materiales',
      icon: FaBox,
      color: '#6c757d',
      component: InsumoForm
    },
    {
      id: 'dotacion',
      nombre: 'Dotación',
      descripcion: 'Solicitar elementos de dotación personal',
      icon: FaShoppingCart,
      color: '#6610f2',
      component: DotacionForm
    },
    {
      id: 'capacitacion',
      nombre: 'Capacitación',
      descripcion: 'Solicitar capacitación o formación',
      icon: FaGraduationCap,
      color: '#198754',
      component: CapacitacionForm
    },
    {
      id: 'incapacidad',
      nombre: 'Incapacidad',
      descripcion: 'Reportar incapacidad médica',
      icon: FaUserMd,
      color: '#dc3545',
      component: IncapacidadForm
    },
    {
      id: 'compensatorio',
      nombre: 'Compensatorio',
      descripcion: 'Solicitar día compensatorio',
      icon: FaCalendarAlt,
      color: '#fd7e14',
      component: CompensatorioForm
    },
    {
      id: 'teletrabajo',
      nombre: 'Teletrabajo',
      descripcion: 'Solicitar trabajo remoto',
      icon: FaLaptop,
      color: '#20c997',
      component: TeletrabajoForm
    },
    {
      id: 'equipamiento',
      nombre: 'Equipamiento',
      descripcion: 'Solicitar equipos o herramientas',
      icon: FaBriefcase,
      color: '#495057',
      component: EquipamientoForm
    },
    {
      id: 'horas_extra',
      nombre: 'Horas Extra',
      descripcion: 'Solicitar horas extra trabajadas',
      icon: FaClock,
      color: '#ffc107',
      component: HorasExtrasForm
    }
  ];

  useEffect(() => {
    cargarRegistros();
  }, []);

  const cargarRegistros = async () => {
    setLoading(true);
    try {
      // Aquí irá el endpoint real
      // const response = await fetch('/api/registros');
      // const data = await response.json();
      
      // Data de prueba
      const dataDemo = [
        { id: 1, tipo: 'permiso', titulo: 'Permiso médico', estado: 'pendiente' },
        { id: 2, tipo: 'vacaciones', titulo: 'Vacaciones diciembre', estado: 'aprobado' }
      ];
      setRegistros(dataDemo);
    } catch (error) {
      console.error('Error al cargar registros:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectType = (tipo) => {
    setSelectedType(tipo);
  };

  const handleCloseForm = () => {
    setSelectedType(null);
    cargarRegistros();
  };

  const handleSubmit = async (formData) => {
    try {
      // Aquí irá el endpoint real
      // await fetch('/api/registros', { method: 'POST', body: JSON.stringify(formData) });
      console.log('Datos del formulario:', formData);
      handleCloseForm();
    } catch (error) {
      console.error('Error al enviar formulario:', error);
    }
  };

  if (selectedType) {
    const FormComponent = selectedType.component;
    return (
      <FormComponent
        onClose={handleCloseForm}
        onSubmit={handleSubmit}
        solicitante={userData}
        tipoRegistro={selectedType}
      />
    );
  }

  return (
    <Container fluid className="registros-container py-4">
      {/*<div class="alert alert-danger py-2 px-3 mb-3">
       ⚠ Esta funcionalidad aún se encuentra en desarrollo.
      </div>*/}
      <div className="registros-header mb-4">
        <h2 className="text-primary fw-bold">
          <FaFileAlt className="me-2" />
          Sistema de Registros
        </h2>
        <p className="text-muted">
          Selecciona el tipo de solicitud que deseas realizar
        </p>
      </div>

      <Row className="g-4">
        {tiposRegistro.map((tipo) => (
          <Col key={tipo.id} xs={12} sm={6} md={4} lg={3}>
            <Card 
              className="registro-card h-100 shadow-sm"
              onClick={() => handleSelectType(tipo)}
              style={{ cursor: 'pointer', borderLeft: `4px solid ${tipo.color}` }}
            >
              <Card.Body className="d-flex flex-column">
                <div className="d-flex align-items-center mb-3">
                  <div 
                    className="icon-wrapper me-3"
                    style={{ 
                      backgroundColor: `${tipo.color}15`,
                      borderRadius: '10px',
                      padding: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <tipo.icon size={24} style={{ color: tipo.color }} />
                  </div>
                  <h5 className="mb-0 fw-bold">{tipo.nombre}</h5>
                </div>
                <p className="text-muted small mb-0 flex-grow-1">
                  {tipo.descripcion}
                </p>
              </Card.Body>
              <Card.Footer 
                className="bg-light border-0"
                style={{
                   borderBottomLeftRadius: '8px', 
                   borderBottomRightRadius: '8px',
                  height: '60px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                >
                <Button 
                  variant="outline-primary" 
                  size="sm" 
                  className="w-100"
                  style={{ 
                    borderColor: tipo.color, 
                    color: tipo.color }}
                >
                  Crear Solicitud
                </Button>
              </Card.Footer>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Registros;